import styled from 'styled-components';

export const StyledPlusMinusButton = styled.button<{ isVisible?: boolean }>`
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  border-style: hidden;
  background-color: #f7f7f7;
  display: flex;
  justify-content: center;
  align-items: center;
  visibility: ${({ isVisible = true }) => (isVisible ? 'visible' : 'hidden')};
  opacity: ${({ isVisible = true }) => (isVisible ? 1 : 0)};
  --offset: 0;
  &:hover {
    cursor: pointer;
  }
`;
